import { render, staticRenderFns } from "./AccionesProductos.vue?vue&type=template&id=105c4836"
import script from "./AccionesProductos.vue?vue&type=script&lang=js"
export * from "./AccionesProductos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports